module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-top-metals-remnants.7f29a4f0.png";